export var AuthActionType;
(function (AuthActionType) {
    AuthActionType["SET_USER"] = "SET_USER";
    AuthActionType["LOGOUT_USER"] = "LOGOUT_USER";
})(AuthActionType || (AuthActionType = {}));
//# sourceMappingURL=auth-action.type.js.map